module.exports = __webpack_public_path__ + "media/images/admin/icons/check-square-6ffba6b563ca941808da8ba3faf7f77d.svg";